<template>
  <div class="flight-list">
    <div class="flight-item" v-for="(flightItem, index) in journeys" :key="index">
      <div class="flight-main">
        <div class="left-part">
          <div class="trip-row" v-for="(segmentItem, segmentIndex) in flightItem.journeySegment" :key="segmentIndex">
            <div class="flight-type" :class="[ segmentItem.journeyType == 2 ? 'return-type' :'' ]" v-if="flightItem.journeySegment.length > 1">{{ segmentItem.journeyType == 1 ? "去程" : "返程" }}</div>
            <Segment :flightItem="segmentItem" />
            <div class="dinner-list" style="width: 300px">
              <DinnerItem v-for="flight in segmentItem.flightSegment" :key="flight.flightIndex" :flightItem="flight" />
              <el-popover trigger="click" placement="bottom-start">
                <div class="flight-detail-list">
                  <div 
                    class="flight-detail-item" 
                    v-for="(item, detailIndex) in segmentItem.flightSegment" 
                    :key="item.flightIndex" 
                    :style="calcDetailStyle(segmentItem, detailIndex)"
                  >
                    <DinnerItem :flightItem="item" style="padding-bottom: 10px;" />
                    <Segment :flightItem="item" showDepDate />
                  </div>
                </div>
                <div slot="reference" class="show-more">航班详情</div>
              </el-popover>
            </div>
          </div>
        </div>
        <div class="right-part">
          <CabinType v-if="flightItem.cabinClassGroup.length > 1" :flightItem="flightItem" :flightIndex="index"  @chooseCurrentCabin="chooseCurrentCabin" />
        </div>
      </div>
      <CabinGroup 
        :flightItem="flightItem" 
        :products="getDisplayProducts(flightItem)" 
        :searchFilter="searchFilter" 
        :resultInfo="resultInfo" 
        :refundTips="refundTips"
      />
    </div>
  </div>
</template>

<script>
import Segment from "@/components/Segment.vue";
import CabinGroup from "./CabinGroup.vue";
import DinnerItem from "@/components/DinnerItem.vue";
import CabinType from "./CabinType.vue";
import { queryIntFlight, queryDict } from "@/api/newsapi";

export default {
  name: "InternationalFlight",

  components: { Segment, CabinGroup, DinnerItem, CabinType },

  props: {
    flights: {
      type: Array,
      default: () => []
    },
  },

  mounted() {
    this.getDicConfigByKey("INT_CHANGE_REFUND_FEE_REMARK", (res) => {
      this.refundTips = res.data.replace(/\\n/g, "<br/>");
    })
  },

  data() {
    return {
      journeys: [],
      searchFilter: {},
      resultInfo: {},
      refundTips: ''
    };
  },

  methods: {
    // 切换展示的仓位产品
    chooseCurrentCabin(flightIndex, cabinIndex) {
      // console.log("flightIndex", flightIndex, "cabinIndex", cabinIndex);
      this.$set(this.journeys[flightIndex], 'cabinIndex', cabinIndex)
    },

    getDisplayProducts(flightItem) {
      return flightItem?.cabinClassGroup?.[flightItem?.cabinIndex || 0]?.products || []
    },

    calcDetailStyle(segmentItem, detailIndex) {
      return { 
        'margin-bottom': '10px', 
        'border-bottom': detailIndex == segmentItem.flightSegment.length - 1 ? '' : '1px solid #dedede',
        padding: detailIndex == segmentItem.flightSegment.length - 1 ? '' : '0 0 15px'
      }
    },

    async loadData(params) {
      this.searchFilter = params;
      try {
        // const mock = { depAirportCode: "CSX", arrAirportCode: "BKK", depDate: "2025-10-15", tripType: "OW", carryChild: true, returnDate: "2025-10-21" };
        const res = await queryIntFlight(params);
        if (res && res.success) {
          this.resultInfo = res.data || {}
          this.journeys = res.data?.journeys || []

        } else {
          this.journeys = []
        }
        return res;
      } catch (error) {
        console.log(error);
      }
    },
    getDicConfigByKey(key, callback) {
      queryDict({ key: key }).then(res => {
        if (res.data) {
          callback && callback(res)
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.flight-list {
  .flight-item {
    position: relative;
    width: 100%;
    // min-height: 300px;
    background: #ffffff;
    margin-bottom: 14px;
    height: fit-content;
  }
  .flight-main {
    height: fit-content;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 2px;
    box-shadow: 0 10px 10px 0 #cccccc;
    position: relative;
    z-index: 1;

    .left-part {
      flex: 1;
      .trip-row {
        display: flex;
        align-items: center;
        height: 160px;
        position: relative;
      }
      .flight-type {
        position: absolute;
        top: 1px;
        left: 0;
        background-color: #d70039;
        color: #fff;
        padding: 4px 20px;
        border-radius: 0 8px 8px 0;
      }
      .return-type {
        background: rgb(255, 49, 34);
      }
    }

    .dinner-list {
      font-size: 14px;
      color: #4d4e4e;
      padding-left: 20px;
      .dinner-item {
        display: flex;
        align-items: center;
        line-height: 30px;
      }
      .show-more {
        width: fit-content;
        line-height: 30px;
        color: #1890ff;
        padding-left: 6px;
        cursor: pointer;
      }
      .flight-detail-item {
        padding: 15px 0;
        border-bottom: 1px solid #dedede;
        &:last-child {
          border: none;
        }
      }
    }
  }
}
</style>
